<template>
  <q-btn v-if="img" flat round dense :color="color" @click="$emit('click')">
    <img :src="img" style="width:26px; height:26px; object-fit:contain;" alt="" />
  </q-btn>
  <q-btn v-else :icon="icon" flat round dense :color="color" @click="$emit('click')" />
</template>

<script>
// Bouton "retour à la page principale" personnalisable (Lot 4 / C), réutilisé dans les overlays média.
// Récupère l'icône/image choisie via inject('returnBtn') fourni par template_6 ; défaut = 'home'.
import { inject, ref } from 'vue';
export default {
  name: 'ReturnHomeButton',
  props: { color: { type: String, default: undefined } },
  emits: ['click'],
  setup() {
    const rb = inject('returnBtn', { icon: ref('home'), img: ref(null) });
    return { icon: rb.icon, img: rb.img };
  },
};
</script>
